// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { AddressOptionalRequest } from './address-optional-request';

/** See com.rev360.pms.api.controller.provider.externalprovider.CreateExternalProviderRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateExternalProviderRequest extends GandalfModelBase {

	@GandalfLabel('Address')
	@GandalfValidator({ notNull: { message: 'Address is required' } })
	@GandalfProperty({ designType: AddressOptionalRequest, isRequired: true })
	address!: AddressOptionalRequest;

	@GandalfLabel('Practice Name')
	@GandalfValidator({ sizeString: { message: 'Practice Name cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfProperty({ designType: String })
	altPracticeName!: string | null;

	@GandalfLabel('API Key')
	@GandalfValidator({ sizeString: { message: 'API Key cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	apiKey!: string | null;

	@GandalfLabel('Cell Phone')
	@GandalfValidator({ sizeString: { message: 'Cell Phone cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ phoneNumber: { message: 'Cell Phone must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	cellPhone!: string | null;

	@GandalfLabel('Cell Phone Ext')
	@GandalfValidator({ sizeString: { message: 'Cell Phone Ext cannot be longer than 10 characters', minLength: 0, maxLength: 10 } })
	@GandalfProperty({ designType: String })
	cellPhoneExt!: string | null;

	@GandalfLabel('Credentials')
	@GandalfValidator({ sizeString: { message: 'Credentials cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfProperty({ designType: String })
	credentials!: string | null;

	@GandalfLabel('DEA #')
	@GandalfValidator({ sizeString: { message: 'DEA # cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	deaNum!: string | null;

	@GandalfLabel('Description')
	@GandalfValidator({ sizeString: { message: 'Description cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfLabel('Direct Address')
	@GandalfValidator({ sizeString: { message: 'Direct Address cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfValidator({ email: { message: 'Invalid format for Direct Address' } })
	@GandalfProperty({ designType: String })
	directAddress!: string | null;

	@GandalfLabel('EIN #')
	@GandalfValidator({ sizeString: { message: 'EIN # cannot be longer than 20 characters', minLength: 0, maxLength: 20 } })
	@GandalfProperty({ designType: String })
	ein!: string | null;

	@GandalfLabel('Email')
	@GandalfValidator({ sizeString: { message: 'Email cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfValidator({ email: { message: 'Invalid email format' } })
	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfLabel('Fax')
	@GandalfValidator({ sizeString: { message: 'Fax cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ phoneNumber: { message: 'Fax must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	fax!: string | null;

	@GandalfLabel('First Name')
	@GandalfValidator({ notNull: { message: 'First Name is required' } })
	@GandalfValidator({ sizeString: { message: 'First Name must be between 1 and 50 characters', minLength: 1, maxLength: 50 } })
	@GandalfProperty({ designType: String, isRequired: true })
	firstName!: string;

	@GandalfConstantDecorator(constants.Gender)
	@GandalfProperty({ designType: constants.Gender })
	gender!: constants.Gender | null;

	@GandalfLabel('Home Phone')
	@GandalfValidator({ sizeString: { message: 'Home Phone cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ phoneNumber: { message: 'Home Phone must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	homePhone!: string | null;

	@GandalfLabel('Home Phone Ext')
	@GandalfValidator({ sizeString: { message: 'Home Phone Ext cannot be longer than 10 characters', minLength: 0, maxLength: 10 } })
	@GandalfProperty({ designType: String })
	homePhoneExt!: string | null;

	@GandalfLabel('Last Name')
	@GandalfValidator({ notNull: { message: 'Last Name is required' } })
	@GandalfValidator({ sizeString: { message: 'Last Name must be between 1 and 100 characters', minLength: 1, maxLength: 100 } })
	@GandalfProperty({ designType: String, isRequired: true })
	lastName!: string;

	@GandalfLabel('License #')
	@GandalfValidator({ sizeString: { message: 'License # cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	licenseNum!: string | null;

	@GandalfLabel('Nickname')
	@GandalfValidator({ sizeString: { message: 'Nickname cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	nickName!: string | null;

	@GandalfLabel('NPI')
	@GandalfValidator({ sizeString: { message: 'NPI must be between 10 and 15 characters', minLength: 10, maxLength: 15 } })
	@GandalfProperty({ designType: String })
	npi!: string | null;

	@GandalfLabel('Pager')
	@GandalfValidator({ sizeString: { message: 'Pager cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ phoneNumber: { message: 'Pager must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	pager!: string | null;

	@GandalfLabel('Practitioner #')
	@GandalfValidator({ sizeString: { message: 'Practitioner # cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	practitionerNum!: string | null;

	@GandalfConstantDecorator(constants.PreferredPhoneType)
	@GandalfLabel('Preferred Phone')
	@GandalfProperty({ designType: constants.PreferredPhoneType })
	preferredPhoneType!: constants.PreferredPhoneType | null;

	@GandalfLabel('Provider Type')
	@GandalfValidator({ notNull: { message: 'Provider Type is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	providerTypeId!: number;

	@GandalfLabel('Registration #')
	@GandalfValidator({ sizeString: { message: 'Registration # cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	registrationNum!: string | null;

	@GandalfLabel('Suffix')
	@GandalfValidator({ sizeString: { message: 'Suffix cannot be longer than 20 characters', minLength: 0, maxLength: 20 } })
	@GandalfProperty({ designType: String })
	suffix!: string | null;

	@GandalfLabel('Title')
	@GandalfProperty({ designType: Number })
	titleId!: number | null;

	@GandalfLabel('UPIN')
	@GandalfValidator({ sizeString: { message: 'UPIN cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	upin!: string | null;

	@GandalfLabel('Work Phone')
	@GandalfValidator({ sizeString: { message: 'Work Phone cannot be longer than 30 characters', minLength: 0, maxLength: 30 } })
	@GandalfValidator({ phoneNumber: { message: 'Work Phone must contain at least 10 digits' } })
	@GandalfProperty({ designType: String })
	workPhone!: string | null;

	@GandalfLabel('Work Phone Ext')
	@GandalfValidator({ sizeString: { message: 'Work Phone Ext cannot be longer than 10 characters', minLength: 0, maxLength: 10 } })
	@GandalfProperty({ designType: String })
	workPhoneExt!: string | null;

}
